import * as $runtime from "../runtime.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Effect$dClass from "../Effect.Class/index.js";
import * as Partial from "../Partial/index.js";
import * as Specular$dInternal$dIncremental from "../Specular.Internal.Incremental/index.js";
import * as Specular$dInternal$dIncremental$dNode from "../Specular.Internal.Incremental.Node/index.js";
import * as Specular$dInternal$dIncremental$dOptional from "../Specular.Internal.Incremental.Optional/index.js";
import * as Specular$dInternal$dProfiling from "../Specular.Internal.Profiling/index.js";
import * as Specular$dInternal$dQueue from "../Specular.Internal.Queue/index.js";
import * as Unsafe$dReference from "../Unsafe.Reference/index.js";
const Behavior = x => x;
const uniqDynPureBy = eq => v => {
  const n = Specular$dInternal$dIncremental.uniqBy(($0, $1) => eq($0)($1), v);
  Specular$dInternal$dIncremental$dNode.annotate(n, "uniqDyn");
  return n;
};
const uniqDynPure = dictEq => uniqDynPureBy(dictEq.eq);
const traceNode = handler => input => {
  const n = Specular$dInternal$dIncremental.traceChanges($0 => handler($0)(), input);
  Specular$dInternal$dIncremental$dNode.annotate(n, "trace");
  return n;
};
const traceEventIO = handler => v => traceNode(handler)(v);
const traceDynIO = handler => v => traceNode(handler)(v);
const $$switch = v => {
  const n = Specular$dInternal$dIncremental.switch(false, v, v1 => v1);
  Specular$dInternal$dIncremental$dNode.annotate(n, "switch");
  return n;
};
const sampleAt = v => v1 => {
  const n = Specular$dInternal$dIncremental.sample((a, b) => b(a), v1, v);
  Specular$dInternal$dIncremental$dNode.annotate(n, "sampleAt");
  return n;
};
const readNode = node => () => {
  Specular$dInternal$dIncremental.addObserver(node, v => {});
  const value = Specular$dInternal$dIncremental$dNode.get_value(node);
  Specular$dInternal$dIncremental.removeObserver(node, v => {});
  return !Unsafe$dReference.reallyUnsafeRefEq(value)(Specular$dInternal$dIncremental$dOptional.none) ? value : Partial._crashWith("Optional.fromSome: none");
};
const readDynamic = dictMonadEffect => v => dictMonadEffect.liftEffect(() => {
  const mark = Specular$dInternal$dProfiling.begin("readDynamic");
  const result = readNode(v)();
  Specular$dInternal$dProfiling.end(mark);
  return result;
});
const readBehavior = v => readNode(v);
const pull = dictMonadEffect => dictMonadEffect.liftEffect;
const never = /* #__PURE__ */ Specular$dInternal$dIncremental.newEvent();
const monadFRP = dictMonadEffect => dictMonadCleanup => ({MonadEffect0: () => dictMonadEffect, MonadCleanup1: () => dictMonadCleanup});
const mapN = f => inputs => {
  const n = Specular$dInternal$dIncremental.mapN(f, inputs);
  Specular$dInternal$dIncremental$dNode.annotate(n, "mapN");
  return n;
};
const map2 = f => v => v1 => {
  const n = Specular$dInternal$dIncremental.map2(($0, $1) => f($0)($1), v, v1);
  Specular$dInternal$dIncremental$dNode.annotate(n, "map2 (" + Specular$dInternal$dIncremental$dNode.get_name(v) + ") (" + Specular$dInternal$dIncremental$dNode.get_name(v1) + ")");
  return n;
};
const leftmost = events => (() => {
  const $0 = Data$dFunctor.arrayMap(v => v)(events);
  return () => {
    const n = Specular$dInternal$dIncremental.leftmost($0);
    Specular$dInternal$dIncremental$dNode.annotate(n, "leftmost");
    return n;
  };
})()();
const globalEffectQueue = /* #__PURE__ */ Specular$dInternal$dQueue.new();
const functorEvent = {
  map: f => v => {
    const n = Specular$dInternal$dIncremental.mapOptional(x => f(x), v);
    Specular$dInternal$dIncremental$dNode.annotate(n, "mapEvent");
    return n;
  }
};
const functorDynamic = {
  map: f => v => {
    const n = Specular$dInternal$dIncremental.map(f, v);
    Specular$dInternal$dIncremental$dNode.annotate(n, "map " + Specular$dInternal$dIncremental$dNode.get_name(v));
    return n;
  }
};
const functorBehavior = functorDynamic;
const filterMapEvent = f => v => {
  const n = Specular$dInternal$dIncremental.mapOptional(
    x => {
      const $0 = f(x);
      if ($0.tag === "Nothing") { return Specular$dInternal$dIncremental$dOptional.none; }
      if ($0.tag === "Just") { return $0._1; }
      $runtime.fail();
    },
    v
  );
  Specular$dInternal$dIncremental$dNode.annotate(n, "filterMapEvent");
  return n;
};
const filterJustEvent = /* #__PURE__ */ filterMapEvent(x => x);
const filterEvent = f => v => {
  const n = Specular$dInternal$dIncremental.mapOptional(
    x => {
      if (f(x)) { return x; }
      return Specular$dInternal$dIncremental$dOptional.none;
    },
    v
  );
  Specular$dInternal$dIncremental$dNode.annotate(n, "filterEvent");
  return n;
};
const drainEffects = () => Specular$dInternal$dQueue.drain(globalEffectQueue, handler => handler());
const stabilize = () => {
  const mark = Specular$dInternal$dProfiling.begin("Specular.stabilize");
  Specular$dInternal$dIncremental.stabilize();
  drainEffects();
  return Specular$dInternal$dProfiling.end(mark);
};
const newDynamic = dictMonadEffect => initial => dictMonadEffect.liftEffect(() => {
  const $$var = Specular$dInternal$dIncremental.newVar(initial);
  Specular$dInternal$dIncremental$dNode.annotate($$var, "root Dynamic");
  return {
    dynamic: $$var,
    read: readDynamic(Effect$dClass.monadEffectEffect)($$var),
    set: x => () => {
      const name = Specular$dInternal$dIncremental$dNode.get_name($$var);
      const mark = Specular$dInternal$dProfiling.begin("set " + name);
      Specular$dInternal$dIncremental.setVar($$var, x);
      stabilize();
      return Specular$dInternal$dProfiling.end(mark);
    },
    modify: f => () => {
      const name = Specular$dInternal$dIncremental$dNode.get_name($$var);
      const mark = Specular$dInternal$dProfiling.begin("modify " + name);
      const x = Specular$dInternal$dIncremental$dNode.valueExc($$var);
      Specular$dInternal$dIncremental.setVar($$var, f(x));
      stabilize();
      return Specular$dInternal$dProfiling.end(mark);
    }
  };
});
const newBehavior = dictMonadEffect => initialValue => dictMonadEffect.liftEffect((() => {
  const $0 = newDynamic(Effect$dClass.monadEffectEffect)(initialValue);
  return () => {
    const v = $0();
    return {behavior: v.dynamic, set: v.set};
  };
})());
const newEvent = dictMonadEffect => dictMonadEffect.liftEffect(() => {
  const evt = Specular$dInternal$dIncremental.newEvent();
  Specular$dInternal$dIncremental$dNode.annotate(evt, "root Event");
  return {
    event: evt,
    fire: x => () => {
      const name = Specular$dInternal$dIncremental$dNode.get_name(evt);
      const mark = Specular$dInternal$dProfiling.begin("fire " + name);
      Specular$dInternal$dIncremental.triggerEvent(evt, x);
      stabilize();
      return Specular$dInternal$dProfiling.end(mark);
    }
  };
});
const current = Behavior;
const tagDyn = dyn => event => sampleAt(functorEvent.map(v => x => x)(event))(dyn);
const changed = v => v;
const changed_ = x => functorDynamic.map(v => {})(x);
const attachDynWith = f => dyn => event => sampleAt(functorEvent.map(b => a => f(a)(b))(event))(dyn);
const applyDynamic = {
  apply: v => v1 => {
    const n = Specular$dInternal$dIncremental.map2(($0, $1) => $0($1), v, v1);
    Specular$dInternal$dIncremental$dNode.annotate(
      n,
      "apply (" + Specular$dInternal$dIncremental$dNode.get_name(v) + ") (" + Specular$dInternal$dIncremental$dNode.get_name(v1) + ")"
    );
    return n;
  },
  Functor0: () => functorDynamic
};
const bindDynamic = {
  bind: v => f => {
    const n = Specular$dInternal$dIncremental.bind_(v, x => f(x));
    Specular$dInternal$dIncremental$dNode.annotate(n, "bindDynamic");
    return n;
  },
  Apply0: () => applyDynamic
};
const bindBehavior = bindDynamic;
const semigroupDynamic = dictSemigroup => (
  {
    append: (() => {
      const $0 = dictSemigroup.append;
      return a => b => applyDynamic.apply(functorDynamic.map($0)(a))(b);
    })()
  }
);
const applyBehavior = applyDynamic;
const applicativeDynamic = {
  pure: x => {
    const n = Specular$dInternal$dIncremental.constant(x);
    Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
    return n;
  },
  Apply0: () => applyDynamic
};
const heytingAlgebraDynamic = dictHeytingAlgebra => (
  {
    tt: (() => {
      const $0 = dictHeytingAlgebra.tt;
      return (() => {
        const n = Specular$dInternal$dIncremental.constant($0);
        Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
        return n;
      })();
    })(),
    ff: (() => {
      const $0 = dictHeytingAlgebra.ff;
      return (() => {
        const n = Specular$dInternal$dIncremental.constant($0);
        Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
        return n;
      })();
    })(),
    implies: (() => {
      const $0 = dictHeytingAlgebra.implies;
      return a => b => applyDynamic.apply(functorDynamic.map($0)(a))(b);
    })(),
    conj: (() => {
      const $0 = dictHeytingAlgebra.conj;
      return a => b => applyDynamic.apply(functorDynamic.map($0)(a))(b);
    })(),
    disj: (() => {
      const $0 = dictHeytingAlgebra.disj;
      return a => b => applyDynamic.apply(functorDynamic.map($0)(a))(b);
    })(),
    not: functorDynamic.map(dictHeytingAlgebra.not)
  }
);
const monadDynamic = {Applicative0: () => applicativeDynamic, Bind1: () => bindDynamic};
const monoidDynamic = dictMonoid => (
  {
    mempty: (() => {
      const $0 = dictMonoid.mempty;
      return (() => {
        const n = Specular$dInternal$dIncremental.constant($0);
        Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
        return n;
      })();
    })(),
    Semigroup0: () => semigroupDynamic(dictMonoid.Semigroup0())
  }
);
const applicativeBehavior = applicativeDynamic;
const monadBehavior = {Applicative0: () => applicativeDynamic, Bind1: () => bindDynamic};
const annotated = name => v => {
  Specular$dInternal$dIncremental$dNode.annotate(v, name);
  return v;
};
const annotate = dictMonadEffect => v => name => dictMonadEffect.liftEffect(() => Specular$dInternal$dIncremental$dNode.annotate(v, name));
const _subscribeNode = (handler, node) => {
  Specular$dInternal$dIncremental.addObserver(
    node,
    value => {
      const $0 = handler(value);
      return Specular$dInternal$dQueue.enqueue(globalEffectQueue, $0);
    }
  );
  return () => Specular$dInternal$dIncremental.removeObserver(
    node,
    value => {
      const $0 = handler(value);
      return Specular$dInternal$dQueue.enqueue(globalEffectQueue, $0);
    }
  );
};
const subscribeNode = dictMonadEffect => dictMonadCleanup => handler => event => dictMonadCleanup.Monad0().Bind1().bind(dictMonadEffect.liftEffect(() => _subscribeNode(
  handler,
  event
)))(unsub => dictMonadCleanup.onCleanup(unsub));
const foldDyn = dictMonadFRP => f => initial => v => dictMonadFRP.MonadCleanup1().Monad0().Bind1().bind(dictMonadFRP.MonadEffect0().liftEffect(() => {
  const n = Specular$dInternal$dIncremental.fold((a, b) => f(a)(b), initial, v);
  Specular$dInternal$dIncremental$dNode.annotate(n, "foldDyn");
  return n;
}))(n => dictMonadFRP.MonadCleanup1().Monad0().Bind1().bind(subscribeNode(dictMonadFRP.MonadEffect0())(dictMonadFRP.MonadCleanup1())(v1 => () => {})(n))(() => dictMonadFRP.MonadCleanup1().Monad0().Applicative0().pure(n)));
const holdDyn = dictMonadFRP => foldDyn(dictMonadFRP)(x => v => x);
const foldDynMaybe = dictMonadFRP => f => initial => v => dictMonadFRP.MonadCleanup1().Monad0().Bind1().bind(dictMonadFRP.MonadEffect0().liftEffect(() => {
  const n = Specular$dInternal$dIncremental.fold(
    (a, b) => {
      const $0 = f(a)(b);
      if ($0.tag === "Nothing") { return Specular$dInternal$dIncremental$dOptional.none; }
      if ($0.tag === "Just") { return $0._1; }
      $runtime.fail();
    },
    initial,
    v
  );
  Specular$dInternal$dIncremental$dNode.annotate(n, "foldDynMaybe");
  return n;
}))(n => dictMonadFRP.MonadCleanup1().Monad0().Bind1().bind(subscribeNode(dictMonadFRP.MonadEffect0())(dictMonadFRP.MonadCleanup1())(v1 => () => {})(n))(() => dictMonadFRP.MonadCleanup1().Monad0().Applicative0().pure(n)));
const holdUniqDynBy = dictMonadFRP => eq => foldDynMaybe(dictMonadFRP)($$new => old => {
  if (eq($$new)(old)) { return Data$dMaybe.Nothing; }
  return Data$dMaybe.$Maybe("Just", $$new);
});
const uniqDynBy = dictMonadFRP => eq => v => dictMonadFRP.MonadCleanup1().Monad0().Bind1().bind(dictMonadFRP.MonadEffect0().liftEffect(() => {
  Specular$dInternal$dIncremental.addObserver(v, v1 => {});
  return Specular$dInternal$dIncremental$dNode.valueExc(v);
}))(initialValue => dictMonadFRP.MonadCleanup1().Monad0().Bind1().bind(foldDynMaybe(dictMonadFRP)($$new => old => {
  if (eq($$new)(old)) { return Data$dMaybe.Nothing; }
  return Data$dMaybe.$Maybe("Just", $$new);
})(initialValue)(v))(uniqDyn_ => dictMonadFRP.MonadCleanup1().Monad0().Bind1().bind(dictMonadFRP.MonadEffect0().liftEffect(() => Specular$dInternal$dIncremental.removeObserver(
  v,
  v1 => {}
)))(() => dictMonadFRP.MonadCleanup1().Monad0().Applicative0().pure(uniqDyn_))));
const uniqDyn = dictMonadFRP => dictEq => uniqDynBy(dictMonadFRP)(dictEq.eq);
const latestJust = dictMonadFRP => dyn => dictMonadFRP.MonadCleanup1().Monad0().Bind1().bind(readDynamic(dictMonadFRP.MonadEffect0())(dyn))(currentValue => foldDynMaybe(dictMonadFRP)($$new => v => {
  if ($$new.tag === "Just") { return Data$dMaybe.$Maybe("Just", Data$dMaybe.$Maybe("Just", $$new._1)); }
  return Data$dMaybe.Nothing;
})(currentValue)(dyn));
const subscribeDyn = dictMonadFRP => handler => v => dictMonadFRP.MonadCleanup1().Monad0().Bind1().bind(dictMonadFRP.MonadEffect0().liftEffect(() => {
  const evt = Specular$dInternal$dIncremental.newEvent();
  Specular$dInternal$dIncremental$dNode.annotate(evt, "subscribeDyn");
  return evt;
}))(evt => dictMonadFRP.MonadCleanup1().Monad0().Bind1().bind(subscribeNode(dictMonadFRP.MonadEffect0())(dictMonadFRP.MonadCleanup1())(x => {
  const $0 = handler(x);
  return () => {
    const value = $0();
    Specular$dInternal$dIncremental.triggerEvent(evt, value);
    return stabilize();
  };
})(v))(() => dictMonadFRP.MonadEffect0().liftEffect(() => {
  const currentValue = Specular$dInternal$dIncremental$dNode.valueExc(v);
  const initialResult = handler(currentValue)();
  Specular$dInternal$dIncremental$dNode.set_value(evt, initialResult);
  return evt;
})));
const subscribeDyn_ = dictMonadFRP => handler => v => dictMonadFRP.MonadCleanup1().Monad0().Bind1().bind(subscribeNode(dictMonadFRP.MonadEffect0())(dictMonadFRP.MonadCleanup1())(handler)(v))(() => dictMonadFRP.MonadEffect0().liftEffect(() => {
  const currentValue = Specular$dInternal$dIncremental$dNode.valueExc(v);
  return handler(currentValue)();
}));
const subscribeEvent_ = dictMonadEffect => dictMonadCleanup => handler => v => subscribeNode(dictMonadEffect)(dictMonadCleanup)(handler)(v);
const _subscribeEvent = (handler, v) => _subscribeNode(handler, v);
export {
  Behavior,
  _subscribeEvent,
  _subscribeNode,
  annotate,
  annotated,
  applicativeBehavior,
  applicativeDynamic,
  applyBehavior,
  applyDynamic,
  attachDynWith,
  bindBehavior,
  bindDynamic,
  changed,
  changed_,
  current,
  drainEffects,
  filterEvent,
  filterJustEvent,
  filterMapEvent,
  foldDyn,
  foldDynMaybe,
  functorBehavior,
  functorDynamic,
  functorEvent,
  globalEffectQueue,
  heytingAlgebraDynamic,
  holdDyn,
  holdUniqDynBy,
  latestJust,
  leftmost,
  map2,
  mapN,
  monadBehavior,
  monadDynamic,
  monadFRP,
  monoidDynamic,
  never,
  newBehavior,
  newDynamic,
  newEvent,
  pull,
  readBehavior,
  readDynamic,
  readNode,
  sampleAt,
  semigroupDynamic,
  stabilize,
  subscribeDyn,
  subscribeDyn_,
  subscribeEvent_,
  subscribeNode,
  $$switch as switch,
  tagDyn,
  traceDynIO,
  traceEventIO,
  traceNode,
  uniqDyn,
  uniqDynBy,
  uniqDynPure,
  uniqDynPureBy
};
